import { render, staticRenderFns } from "./QuoteRequestMailForm.vue?vue&type=template&id=42bda05c&scoped=true&"
import script from "./QuoteRequestMailForm.vue?vue&type=script&lang=ts&"
export * from "./QuoteRequestMailForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteRequestMailForm.vue?vue&type=style&index=0&id=42bda05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bda05c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
